const isDevelopmentEnvironment = (window.location.hostname.indexOf('localhost') !== -1 && window.location.port === '8080');

export default {

    'fullAccessText': '(Full Access)',
    'internetOptions': [
        {
            text: 'Apply Categories only',
            text2: 'Categories only',
            frText2: 'Filtrage par catégories',
            itText2: 'Solo categorie',
            value: 'open',
        },
        {
            text: 'Apply Rules and Categories',
            text2: 'Rules and Categories',
            frText2: 'Filtrage fin',
            itText2: 'Regole e categorie',
            value: 'filtered',
        },
        {
            text: 'No Internet access',
            text2: 'No Internet access',
            frText2: 'Internet fermé',
            itText2: 'Nessun accesso Internet',
            value: 'none',
        },
    ],
    'internetOptionsFr': [
        {
            text: 'Ouvert',
            text2: 'Ouvert',
            value: 'open',
        },
        {
            text: 'Filtré',
            text2: 'Filtré',
            value: 'filtered',
        },
        {
            text: 'Aucun',
            text2: 'Aucun',
            value: 'none',
        },
    ],
    'internetOptionsIt': [
        {
            text: 'Solo categorie',
            text2: 'Solo categorie',
            value: 'open',
        },
        {
            text: 'Regole e categorie',
            text2: 'Regole e categorie',
            value: 'filtered',
        },
        {
            text: 'Nessun accesso Internet',
            text2: 'Nessun accesso Internet',
            value: 'none',
        },
    ],
    'defaultProfileName': 'Default', // Changes here should also be made in the get.php
    'isDevelopmentEnvironment': isDevelopmentEnvironment,
    'localStorageInternetFilterTabRuleCompact': 'settings.home.internetFilterTab.ruleCompact',
    'localStorageMobileAppsTabAlertForLongPress': 'settings.home.mobileApps.mobileAlertForLongPress',
    'localStorageInternetFilterTabLayout': 'settings.home.internetFilterTab.layout',
    'mobileAppsTabId': 5,
    login: {
        'ftpOnly': 'ftp only',
    },
    'onlineServerIpUri': 'http://51.159.157.197/',
    'userTabIndex': 0,
    'categoriesTabIndex': 1,
    'rulesTabIndex': 2,
    'groupsTabIndex': 3,
    'mobileAppsTabIndex': 4,
    'informationTabIndex': 5,
    'lightDir': isDevelopmentEnvironment ? '/src/data/light' : '/var/light'
}